import Icon, { ICON_CLOSE } from '~/components/icon/index.js';
import { QueryEncodedLink as Link } from '~/utils/navigation';

/**
 * @param {{ href?: object | string, className?: string, onClick: React.MouseEventHandler, 'data-at'?: string}} props
 */
function IconChevronLinkClose({ href, className, onClick, 'data-at': dataAt, ...rest }) {
	if (href) {
		return (
			<Link href={href} className={className} data-at={dataAt} {...rest}>
				<Icon type={ICON_CLOSE} />
			</Link>
		);
	}

	if (onClick) {
		return (
			<button type="button" className={className} onClick={onClick} data-at={dataAt}>
				<Icon type={ICON_CLOSE} />
			</button>
		);
	}

	return null;
}

export default IconChevronLinkClose;
